<template>
    <div class="p-clock" :class="[running ? 'p-clock--running' : 'p-clock--stopped', { 'l-clock': stacked }]">
        <v-menu offset-y :z-index="20">
            <template v-slot:activator="{ on, attrs }">
                <button type="button" class="p-clock__quarter" title="Change period" v-bind="attrs" v-on="on">
                    <span class="p-clock__quarter-label">Period</span>
                    <span class="p-clock__quarter-value">
                        {{ quarterLabel }}<v-icon small>mdi-menu-down</v-icon>
                    </span>
                </button>
            </template>
            <v-list dense class="py-0">
                <v-list-item
                    v-for="item in quarterItems"
                    :key="item.value"
                    :input-value="item.value === quarter"
                    color="primary"
                    @click="$emit('update:quarter', item.value)"
                >
                    <v-list-item-title class="font-weight-bold">{{ item.text }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <button type="button" class="p-clock__toggle" :title="running ? 'Stop clock' : 'Start clock'" @click="$emit('toggle')">
            <v-icon color="white">{{ running ? 'mdi-pause' : 'mdi-play' }}</v-icon>
        </button>
        <button type="button" class="p-clock__time" title="Edit time" @click="$emit('edit')">
            {{ time }}
            <v-icon small class="p-clock__edit">mdi-pencil</v-icon>
        </button>
        <button type="button" class="p-clock__timeout" title="Timeout" @click="$emit('timeout')">
            <v-icon small>mdi-timer-pause-outline</v-icon>
            <span>TO</span>
        </button>
        <!-- the last clock event did not reach the server: the live stream may show another clock -->
        <button
            v-if="sync === 'failed'"
            type="button"
            class="p-clock__sync"
            title="The clock did not reach the live stream: tap to send it again"
            @click="$emit('resync')"
        >
            <v-icon small color="white">mdi-cloud-alert</v-icon>
            <span>Not sent · retry</span>
        </button>
        <stats-live-screen v-if="matchId" :match-id="matchId" @pause-clock="$emit('pause')" />
    </div>
</template>

<script>
    import StatsLiveScreen from '@/components/stats/StatsLiveScreen'

    // Game clock: period picker, start/stop, time (tap to edit), timeout, and a retry mark when the
    // live stream did not get the clock.
    // stacked = two rows (period + timeout on top, the clock below) for narrow columns
    export default {
        name: 'StatsClock',
        components: { StatsLiveScreen },
        props: {
            quarter: {
                type: Number,
                default: 1
            },
            quarterItems: {
                type: Array,
                default: () => []
            },
            quarterLabel: {
                type: String,
                default: ''
            },
            running: {
                type: Boolean,
                default: false
            },
            time: {
                type: String,
                default: '00:00'
            },
            stacked: {
                type: Boolean,
                default: false
            },
            // shows what the live stream page has on screen, with a menu to switch it
            matchId: {
                type: [Number, String],
                default: null
            },
            // whether the last clock event reached the server: 'ok' | 'pending' | 'failed'
            sync: {
                type: String,
                default: 'ok'
            }
        }
    }
</script>

<style scoped>
.p-clock__sync {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-basis: 100%;
    height: 32px;
    border-radius: 10px;
    background: #e53935;
    color: #fff;
    font-size: 12px;
    font-weight: 800;
    animation: clock-sync-blink 1.2s ease-in-out infinite;
}
/* the stacked (landscape) clock is a grid: a row of its own */
.l-clock .p-clock__sync {
    grid-column: 1 / -1;
}
@keyframes clock-sync-blink {
    50% {
        opacity: 0.6;
    }
}
</style>
